import React, { HTMLAttributes, forwardRef } from "react";
import { cn } from "@/lib/utils";

export interface ThemedBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  /** Badge variant */
  variant?: "default" | "primary" | "secondary" | "outline";
  /** Badge size */
  size?: "sm" | "md" | "lg";
  /** Custom background color class */
  colorClass?: string;
}

export const ThemedBadge = forwardRef<HTMLSpanElement, ThemedBadgeProps>(
  ({ variant = "default", size = "md", colorClass, className, children, ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(
          // Base styles
          "inline-flex items-center justify-center",
          "[font-weight:var(--theme-font-weight-button)]",
          // Theme-aware styles
          "border-theme rounded-theme shadow-theme-sm",
          // Variant styles
          variant === "default" && (colorClass || "bg-gray-100 text-gray-800"),
          variant === "primary" && (colorClass || "bg-theme-primary text-black"),
          variant === "secondary" && (colorClass || "bg-theme-secondary text-white"),
          variant === "outline" && "bg-white text-black",
          // Size styles
          size === "sm" && "px-2 py-0.5 text-xs gap-1",
          size === "md" && "px-3 py-1 text-sm gap-1.5",
          size === "lg" && "px-4 py-1.5 text-base gap-2",
          className
        )}
        {...props}
      >
        {children}
      </span>
    );
  }
);

ThemedBadge.displayName = "ThemedBadge";
